import auth0 from "auth0-js";

import EventEmitter from "EventEmitter";
import router from "@/router";
import { HTTP } from "@/http-common";
import AUTH_CONFIG from "@/Auth/auth0-variables.js";

export default class AuthService {
  authenticated = this.isAuthenticated();
  authNotifier = new EventEmitter();

  constructor() {
    this.login = this.login.bind(this);
    this.passwordLogin = this.passwordLogin.bind(this);
    this.setSession = this.setSession.bind(this);
    this.logout = this.logout.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.userProfile = this.userProfile.bind(this);
  }

  userProfile() {}

  auth0 = new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientID,
    redirectUri: AUTH_CONFIG.redirectUri,
    responseType: "token id_token",
    scope: "openid profile email roles"
  });

  login() {
    this.auth0.authorize();
  }

  passwordLogin({ username, password }) {
    return new Promise((resolve, reject) => {
      this.auth0.login(
        {
          realm: "Username-Password-Authentication",
          username: username,
          password: password
        },
        function(err) {
          if (err) reject(err);
          else resolve();
        }
      );
    });
  }

  handleAuthentication() {
    const vm = this;
    return new Promise((resolve, reject) => {
      vm.auth0.parseHash((err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          resolve(authResult);
        } else if (err) {
          reject(err);
        }
      });
    });
  }

  setSession(authResult) {
    // Set the time that the Access Token will expire at

    let expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    );
    localStorage.setItem("access_token", authResult.accessToken);
    localStorage.setItem("id_token", authResult.idToken);
    localStorage.setItem("user", authResult.idTokenPayload);
    localStorage.setItem("expires_at", expiresAt);
    this.userProfile = authResult.idTokenPayload;
    HTTP.defaults.headers.common["Authorization"] =
      "Bearer " + authResult.idToken;
    this.authNotifier.emit("authChange", {
      authenticated: true
    });
  }

  logout() {
    // Clear Access Token and ID Token from local storage
    localStorage.removeItem("access_token");
    localStorage.removeItem("id_token");
    localStorage.removeItem("expires_at");
    localStorage.removeItem("user");
    this.userProfile = null;
    this.authNotifier.emit("authChange", false);
    // navigate to the home route
    router.replace("home");
  }

  isAuthenticated() {
    // Check whether the current time is past the
    // Access Token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem("expires_at"));
    return new Date().getTime() < expiresAt;
  }
}
